import ajax from '../utils/request'
import utils from 'gkSrc/utils'
import localStorage from 'gkSrc/utils/local.storage'
import cookie from './cookie'

export default {
  ...utils,
  storage: {
    get: (key) => {
      let storageCache = localStorage.get(key)
      return storageCache
      // let cookieCache = cookie.get(key)
      // return Object.assign({}, storageCache, cookieCache)
    },
    set: (key, value) => {
      localStorage.set(key, value)
      cookie.set(key, value)
    },
    remove (key) {
      localStorage.remove(key)
      cookie.remove(key)
    }
  },
  login () {
    window.location.href = 'https://account.geekbang.org/infoq/login?redirect=' + encodeURIComponent(window.location.href)
  },
  register () {
    window.location.href = 'https://account.geekbang.org/infoq/signup?redirect=' + encodeURIComponent(window.location.href)
  },
  account () {
    window.open('//account.geekbang.org/dashboard/info')
  },
  bindInfoq () {
    window.open('https://account.geekbang.org/infoq/bind?redirect=' + encodeURIComponent(window.location.href))
  },
  search (key = '') {
    window.open(`https://s.geekbang.org/search/c=0/k=${key}/t=`)
  },
  initWxConfig () {
    return new Promise((resolve, reject) => {
      if (!this.isInWeixin()) {
        resolve()
        return
      }

      let url = window.location.href

      // alert(1)
      // axios.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`)
      ajax({
        type: 'get',
        url: `https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`
      }).then(response => {
        // alert(2)
        try {
          // alert(3)
          window.wx.config({
            debug: false,
            appId: response.appId, // 必填，公众号的唯一标识
            timestamp: String(response.timestamp), // 必填，生成签名的时间戳
            nonceStr: response.nonceStr, // 必填，生成签名的随机串
            signature: response.signature, // 必填，签名，见附录1
            jsApiList: ['getLocation', 'openLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'showMenuItems', 'hideMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
        } catch (err) {
          // alert(4)
          console.log(err)
        }
        resolve()
      // }, response => {
      //   alert(response)
      //   resolve()
      //   // window.alert('请求出错了')
      }).catch(err => {
        console.log(err)
        // alert(err)
        resolve()
      })
    })
  },
  /**
   * 是否是微信浏览器内
   *
   * @return   {boolean} 如果是微信环境则返回 true
   */
  isInWeixin: () => {
    const ua = window.navigator.userAgent
    return !!ua.match(/MicroMessenger/i)
  },
  /**
   * 是否是 iOS 浏览器内
   *
   * @return   {boolean} 如果是 iOS 环境则返回 true
   */
  isIOS: () => {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  /**
   * CDN 的图片处理
   * @see https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.6.1147.3b4d5b80nblRUg
   * @param {Url}     url               图片地址
   * @param {Object}  options           图片配置
   * @param {Object}  options.crop      裁剪图片
   * @param {Number}  options.crop.x    裁剪区的左上角 x 坐标
   * @param {Number}  options.crop.y    裁剪区的左上角 y 坐标
   * @param {Number}  options.crop.w    裁剪区宽度
   * @param {Number}  options.crop.h    裁剪区高度
   * @param {String}  options.crop.g    设置裁剪的原点位置 [nw,north,ne,west,center,east,sw,south,se]
   * @param {Object}  options.resize    缩放图片
   * @param {Number}  options.resize.w  缩放宽度
   * @param {Number}  options.resize.h  缩放高度
   * @param {Number}  options.resize.m  缩放高度
   * @param {Number}  options.resize.l  缩放高度
   * @param {Number}  options.resize.s  缩放高度
   * @param {Number}  options.resize.p  缩放百分比
   */
  image (url, options = {}) {
    const extra = []
    const crop = []
    const resize = []

    // 裁剪参数
    if (options.crop) {
      options.crop.x && crop.push(`x_${options.crop.x}`)
      options.crop.y && crop.push(`y_${options.crop.y}`)
      options.crop.w && crop.push(`w_${options.crop.w}`)
      options.crop.h && crop.push(`h_${options.crop.h}`)
      options.crop.g && crop.push(`g_${options.crop.g}`)

      crop.length && extra.push(`crop,${crop.join(',')}`)
    }

    // 缩放参数
    if (options.resize) {
      options.resize.w && resize.push(`w_${options.resize.w}`)
      options.resize.h && resize.push(`h_${options.resize.h}`)
      options.resize.p && resize.push(`p_${options.resize.p}`)

      resize.length && extra.push(`resize,${resize.join(',')}`)
    }

    const oss = extra.length ? extra.join('/') : ''
    return `${url}${oss ? '?x-oss-process=image/' + oss : ''}`
  },

  /**
   * 给内容中的英文或数字自动增加前后空格
   * a 标签内只是英文时 前后也加空格
   *
   * @param    {string}  text 要自动加空格的内容
   * @return   {string}       处理完空格后的内容
   */
  formatContent (text) {
    if (typeof text !== 'string') return ''
    text = text.replace(/([\u4E00-\u9FA5]|<a.*?>)([a-z0-9@&;=_[$%^*\-+(/])/ig, '$1 $2')
    text = text.replace(/([a-z0-9!~&;=_\],.:?$%^*\-+)/])(<\/a>|[\u4E00-\u9FA5])/ig, '$1 $2')
    return text
  },
  /**
   * 给评论数据里的 链接 加上 a 标签
   */
  formatComment (text) {
    if (typeof text !== 'string') return ''
    const REG = /https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*/ig
    text = text.replace(/<([^>]*)>/g, '&lt;$1&gt;') //  将html标签 转义 防注入
    text = text.replace(/\n/g, '<br />') // 回车符替换成 br 标签
    text = text.replace(REG, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener nofollow">${url}</a>`
    })
    return text
  },

  /**
   * 解析指定节点的数学公式
   *
   * @param    {element}  elem 要解析内容中公式的节点
   * @return   void
   */
  handleMathJax: function (elem) {
    if (!document.querySelector('script#MathJax')) {
      let scriptNode = document.createElement('script')
      scriptNode.id = 'MathJax'
      scriptNode.src = '//cdn.bootcss.com/mathjax/2.7.0/MathJax.js?config=TeX-AMS-MML_HTMLorMML'
      document.getElementsByTagName('head')[0].appendChild(scriptNode)
      scriptNode.onload = event => {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, elem])
      }
    } else {
      window.MathJax && window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, elem])
    }
  },

  /**
   * 分享到微博
   * @param {Url}    url    分享网址
   * @param {String} title  分享标题
   * @param {Url}    image  分享图片
   */
  weiboShare ({url, title, image}) {
    let arr = [
      `url=${encodeURIComponent(url)}`,
      `title=${title}`
    ]

    image && arr.push(`pic=${image}`)

    window.open(`http://service.weibo.com/share/share.php?sharesource=weibo&appkey=577532191&${arr.join('&')}`)
  },
  /**
   * 微信分享
   * @param {Object} opts   分享参数
   * @param {String} title  分享标题
   * @param {String} desc   分享描述
   * @param {String} imgUrl 分享图标
   */
  shareWeixin (opts) {
    if (!this.isInWeixin()) return

    const defaultOption = {
      title: document.title,
      desc: '',
      link: window.location.href,
      success: function () {}
    }

    let option = Object.assign(defaultOption, opts)

    option.imgUrl = option.imgUrl || 'https://static001.infoq.cn/static/infoq/www/img/InfoQ-share-icon2.jpg'

     // 需在用户可能点击分享按钮前就先调用
    window.wx && window.wx.ready(function () {
      window.wx.updateAppMessageShareData(option)

      window.wx.updateTimelineShareData(option)
    })
  },
  /**
   * 倒计时过滤方法
   * @param {Number} timediff 两个时间戳的 时间差
   * @return {String} xx天 xx小时xx分xx秒
   */
  formatTimeDown (timediff, type) {
    if (timediff > 0) {
      let hour = Math.floor(timediff / 1000 / 60 / 60)
      let minute = Math.floor(timediff / 1000 / 60 % 60)
      let second = Math.floor(timediff / 1000 % 60)
      return {
        hour,
        minute,
        second,
        done: false
      }
      // return day > 2 ? `${day} 天 ${hour} : ${minute} : ${second}` : `${hour} : ${minute} : ${second}`
    } else {
      return {
        hour: 0,
        minute: 0,
        second: 0,
        done: true
      }
    }
  },
  /**
   * 格式化数字   小于 10 的时候  前边补位
   * @param {Number} val 输入一个数字
   */
  formatNumber (val) {
    return val < 10 ? `0${val}` : val
  },
  /**
   * 给 url 增加指定的参数，如果 url 中有该参数则替换
   *
   * @param    {string}  url 要加参数的 url
   * @param    {string}  key 要增加的参数名
   * @param    {string}  val 要增加的参数值
   * @return   {string}      处理完的 url
   */
  addUrlParam: (url, key, val) => {
    let newParam = key + '=' + encodeURIComponent(val)
    let params = '?' + newParam
    // If the 'url' string exists, then build params from it
    if (url) {
      // Try to replace an existance instance
      params = url.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam)
      // If nothing was replaced, then add the new param to the end
      if (params === url && url.indexOf(newParam) < 0) {
        params += (url.indexOf('?') > 0 ? '&' : '?') + newParam
      }
    }
    return params
  }
}
